import { formatDateTime, parseUtcMs } from "@/utils/datetime";
import { Text, type DataTableColumn } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import { hatcheryTextModes } from "@/app/theme";
import type { PartKindMeta } from "./partsCatalog";
import type { PartsTableRow } from "./PartsTableRow";
import styles from "./EmbodimentPage.module.css";

function textCell(value: string | null): ReactNode {
  if (value === null || value === "") {
    return <span className={styles.labelEmpty}>-</span>;
  }
  return <Text variant={hatcheryTextModes["caption-normal"]}>{value}</Text>;
}

// 부품 컬럼. 종류에 따라 tag 컬럼 표시 여부가 다르다.
export function createPartsColumns(meta: PartKindMeta): readonly DataTableColumn<PartsTableRow>[] {
  const columns: DataTableColumn<PartsTableRow>[] = [
    {
      key: "name",
      header: "이름",
      width: "minmax(200px, 1fr)",
      render: (row) => <Text variant={hatcheryTextModes["body-bold"]}>{row.name}</Text>,
    },
  ];

  if (meta.hasTag) {
    columns.push({
      key: "tag",
      header: "태그",
      width: "160px",
      render: (row) => textCell(row.tag),
    });
  }

  columns.push(
    {
      key: "description",
      header: "설명",
      width: "minmax(200px, 1fr)",
      render: (row) => (
        <Text variant={hatcheryTextModes["body-normal"]} className={styles.description}>
          {row.description ?? "-"}
        </Text>
      ),
    },
    {
      key: "modified_at",
      header: "수정일",
      width: "180px",
      format: (value) => formatDateTime(parseUtcMs(String(value))),
    },
  );

  return columns;
}
